module.exports = __webpack_public_path__ + "static/media/rome-14.f776d8a7.jpg";